module.exports = __webpack_public_path__ + "pc/img/img_award2022_03.069b74a6.webp";